import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { FileService } from "../../../core/services/file.service";
import { PipesModule } from "../../../gyzmo-commons/helpers/pipes/pipes.module";
import { EquipmentInfoComponent } from "./equipment-info.component";

@NgModule(
    {
        declarations: [
            EquipmentInfoComponent,
        ],
        imports: [
            CommonModule,
            IonicModule,
            HttpClientModule,
            TranslateModule,
            PipesModule,
        ],
        exports: [
            EquipmentInfoComponent,
        ],
        providers: [
            FileService,
        ],
    })
export class EquipmentInfoComponentModule {
}
